module.exports = "<rte-navbar *ngIf=\"appService.currentUser != null\"></rte-navbar>\n<rte-app-login *ngIf=\"appService.currentUser == null\"></rte-app-login>"